import { CheckCircle2, Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"
import type { PipelineStep } from "@/reducers/agentPipelineSlice"

type AIChatPipelineStepsProps = {
  steps: PipelineStep[]
}

export function AIChatPipelineSteps({ steps }: AIChatPipelineStepsProps) {
  if (steps.length === 0) return null

  return (
    <div className="mb-2 flex flex-col gap-1.5">
      {steps.map((step) => (
        <div
          key={step.stepId ?? `${step.type}-${step.name}`}
          className="flex items-center gap-2 text-sm"
        >
          {step.status === "done" ? (
            <CheckCircle2 className="size-3.5 shrink-0 text-emerald-500" />
          ) : (
            <Loader2 className="size-3.5 shrink-0 animate-spin text-muted-foreground" />
          )}
          <span
            className={cn(
              "transition-colors",
              step.status === "done"
                ? "text-muted-foreground"
                : "text-foreground",
            )}
          >
            {step.label}
          </span>
        </div>
      ))}
    </div>
  )
}
